import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {DropdownItem, DropdownMenu, DropdownToggle, Dropdown} from 'reactstrap'
import {connect} from 'react-redux'
import {logout} from '../../actions/user'
import {withApollo} from 'react-apollo'
import GridSettingsModal from '../Profile/settings/SettingsModal'

class HeaderDropdown extends Component {

  constructor(props) {
    super(props)
    this.state = {
      dropdownOpen: false,
      grid_settings_modal: false
    }
    this.toggle = this.toggle.bind(this)
  }

  static propTypes = {
    logout: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    })
  }

  dropAccnt() {
    return (
      <div>
        <GridSettingsModal
          isOpened={this.state.grid_settings_modal}
          onCancel={() => this.setState({grid_settings_modal: false})}
          afterSubmit={() => {
            this.setState({grid_settings_modal: false})
            this.props.history.push(this.props.history.location)
          }}
        />
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle nav>
            <b>{this.props.user.data.email}</b>
          </DropdownToggle>
          <DropdownMenu right>
            {window.location.pathname !== '/profile' &&
            [<DropdownItem key='settings-header' header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>,
              <DropdownItem key='settings-link' onClick={() => {
                this.setState({grid_settings_modal: true})
              }}>
                <i className="icon-settings"/> Application settings
              </DropdownItem>]}
            <DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
            <DropdownItem onClick={() => {
              this.props.history.push('/profile')
            }}>
              <i className="fa fa-user"/> Profile
            </DropdownItem>
            <DropdownItem onClick={() => {
              this.props.logout()
              this.props.client.resetStore()
            }}>
              <i className="fa fa-lock"/> Logout
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    )
  }

  render() {
    return (
      this.dropAccnt()
    )
  }
}

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps, {logout})(withApollo(HeaderDropdown))



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js